/*@flow*/
import { useEffect } from 'react';
import { attach } from './events';

export default <T: Object>(
  props: {
    owner: Leaflet$Map,
    options: T,
  },
  element: ?Leaflet$ILayer
) => {
  const { owner, options } = props;

  // Add layer to owner
  useEffect(() => {
    if (!element) return;
    if (!owner) return;
    owner.addLayer(element);

    // Remove layer from owner.
    return () => {
      if (!element) return;
      if (!owner) return;
      owner.removeLayer(element);
    };
  }, [element, owner]);

  // Attach element events to owner.
  useEffect(() => {
    if (!element) return;
    if (!options) return;
    const { on } = options;
    on && attach(on, element, owner);
  }, [options, element]);
};
